import React from 'react';

import { App } from '../../App';
import { Stack, StyledLeftSideBar, Surface } from '../../styles/Containers'
import { AccountForm } from './AccountForm'
import { RouteBreadCrumbs } from '../../routes';
import { SettingsNavigation } from '../../capturecollab/components/Dashboard/SettingsNavigation';
import { StorageUsage } from '../../capturecollab/components/Usage/StorageUsage';
import { Divider } from '@mui/material';
import { StyledP, StyledB, StyledA } from '../../styles/StyledHTML';
import { config } from '../../config';
import styled from 'styled-components';
import { Theme } from '../../styles/Theme';

const StyledUpdate = styled(Surface)`
    border: ${Theme.borderWidth} solid currentColor;
`

export const SettingsPage = () => {

    return (
        <App title="Settings">
            <StyledLeftSideBar>
                <SettingsNavigation />
                <Stack>
                    {/* <StyledP>Manage Your Account</StyledP>
                    <StyledP light>Use the navigation to manage your account.</StyledP>
                    <Divider /> */}

                    <StyledP>
                        <StyledA href="mailto:support@capturecollab.com?subject=Feature Request" button>Suggest A Feature</StyledA>
                    </StyledP>
                    <Divider />

                    <StyledP><StyledB>Just Launched:</StyledB></StyledP>
                    <StyledUpdate>
                        <StyledP><StyledB>Hosted Batch Downloads</StyledB></StyledP>
                        <StyledP light>We're now hosting your zips so that you can come back to them later.</StyledP>
                    </StyledUpdate>
                    <StyledUpdate>
                        <StyledP><StyledB>Support for ARW Raw files</StyledB></StyledP>
                        <StyledP light>We now support this Raw version.</StyledP>
                    </StyledUpdate>
                    <StyledUpdate>
                        <StyledP><StyledB>Quicker Uploads</StyledB></StyledP>
                        <StyledP light>We've rebuilt the way we upload to make things faster.</StyledP>
                    </StyledUpdate>
                    <StyledUpdate>
                        <StyledP><StyledB>Working Files</StyledB></StyledP>
                        <StyledP light>Attach working files to an Asset. Upload a logo png and attach the Illustrator file. :) </StyledP>
                    </StyledUpdate>
                    <StyledUpdate>
                        <StyledP><StyledB>Shift Click Selection</StyledB></StyledP>
                        <StyledP light>Select more photos at once by shift selection.</StyledP>
                    </StyledUpdate>
                    <StyledUpdate>
                        <StyledP><StyledB>CMD or CTRL Click to Edit</StyledB></StyledP>
                        <StyledP light>In the feed of photos hold cmd or ctrl and click to instantly enter edit mode.</StyledP>
                    </StyledUpdate>
                    <StyledUpdate>
                        <StyledP><StyledB>Clean Photo Grid</StyledB></StyledP>
                        <StyledP light>Adds a cleaner view of the photos in a grid.</StyledP>
                    </StyledUpdate>
                    <StyledUpdate>
                        <StyledP><StyledB>Video Support</StyledB></StyledP>
                        <StyledP light>Upload, tag and share video with your team.</StyledP>
                    </StyledUpdate>
                    <StyledUpdate>
                        <StyledP><StyledB>Sort By Uploaded vs Captured Date</StyledB></StyledP>
                        <StyledP light>Control the order of the feed.</StyledP>
                    </StyledUpdate>
                    <StyledUpdate>
                        <StyledP><StyledB>Filter By Date Range</StyledB></StyledP>
                        <StyledP light>View a segment of assets between two dates</StyledP>
                    </StyledUpdate>
                    <Divider />
                    <StyledP light small>App Version: {config.version}</StyledP>

                </Stack>
            </StyledLeftSideBar>
        </App>
    )
}